var frca = {
	"price-platform": {
	unit: "unité",
	"setup-fee": "frais d’installation",
	"includes-setup-fee": "Frais d’installation compris",
	"no-setup-fee": "Pas de frais d’installation",
	"no-minimum-quantity": {
		value: "Pas de quantité minimum",
		_context: "Max length 25"
	},
	"minimum-quantity": {
		value: "Quantité minimale {{0}}",
		_context: "Max length 25"
	},
	"minimum-quantity-units": "{{0}} unités minimum",
	"volume-discount": {
		value: "{{0}}% de remise sur les volumes",
		length: 50,
		_context: "Do not use 'de' in Spanish => it should be {{0}} % descuento por volumen"
	},
	"volume-discount-sale": "{{0}}% de remise sur les volumes + solde",
	"price-suffix": {
		total: "total"
	},
	"delivery-not-included": "Livraison non incluse",
	"tariff-surcharge": "Des droits de douane surtaxés sont susceptibles d’être appliqués",
	"tariff-surcharge-popover": "Ce produit est concerné par les nouvelles taxes douanières sur les importations chinoises vers les États-Unis. Une surtaxe est susceptible d’être appliquée lors du paiement. Si vous avez besoin d’aide pour étudier d’autres options, appelez le 833 972-2437.",
	"tariff-surcharge-aria-label": "Fenêtre indiquant les détails de la surtaxe"
}
};

export { frca as default };
//# sourceMappingURL=src-localization-texts-fr-ca.json.js.map
